import React from "react";
import { Mail, Phone, Smartphone } from "lucide-react";
import { useApi, fetchTeam, fetchTasks } from "../api";
import { Avatar, PageHeader, Loading, ErrorState } from "../components/common";

export default function TeamMembers() {
  const { data: team, loading, error, reload } = useApi(fetchTeam);
  const { data: tasks } = useApi(fetchTasks);
  if (error) return <ErrorState message={error} onRetry={reload} />;
  if (loading || !team) return <Loading />;

  const activeFor = (name) => (tasks || []).filter((t) => t.assignee === name && t.status !== "Complete" && t.status !== "Completed").length;

  return (
    <div className="mx-auto max-w-7xl animate-fade-in-up">
      <PageHeader title="Team Members" subtitle={`${team.length} EP Group team members`} />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {team.map((m) => (
          <div key={m.id} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md">
            <div className="flex items-center gap-4">
              <Avatar avatar={{ name: m.name, initials: m.initials, color: m.color }} size={56} />
              <div className="min-w-0"><h3 className="truncate text-base font-bold text-slate-900">{m.name}</h3><p className="truncate text-sm text-slate-500">{m.role || "Team Member"}</p></div>
            </div>
            <div className="mt-5 space-y-2 text-sm">
              {m.email && <div className="flex items-center gap-2.5 text-slate-600"><Mail className="h-4 w-4 text-slate-400" /> <span className="truncate">{m.email}</span></div>}
              {m.phone && <div className="flex items-center gap-2.5 text-slate-600"><Phone className="h-4 w-4 text-slate-400" /> {m.phone}</div>}
              {m.mobile && <div className="flex items-center gap-2.5 text-slate-600"><Smartphone className="h-4 w-4 text-slate-400" /> {m.mobile}</div>}
            </div>
            <div className="mt-5 border-t border-slate-100 pt-4">
              <span className="inline-block rounded-lg bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-700">{activeFor(m.name)} active task{activeFor(m.name) !== 1 ? "s" : ""}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
